<template>
  <div>
    <div class="info">
      <div>
        成果名称：
        <b>{{ user.Title }}</b>
      </div>
      <div>
        申报单位：
        <b>{{ user.companyname }}</b>
      </div>
      <div class="left-button">
        <p>成果报告申请表:</p>
        <div class="lastBtn">
          <el-button
            type="primary"
            style="width: 1rem"
            @click="view('成果报告申请表', 1)"
            >预览</el-button
          >
          <el-button
            style="width: 1rem; background: rgb(243, 37, 47); color: #fff"
            @click="dowCg(1)"
            >下载</el-button
          >
        </div>
      </div>
      <div class="left-button">
        <p>成果主报告:</p>
        <div class="sendBtn">
          <el-button
            type="primary"
            style="width: 1rem"
            @click="view('成果主报告', 2)"
            >预览</el-button
          >
          <el-button
            style="width: 1rem; background: rgb(243, 37, 47); color: #fff"
            @click="dowCg(2)"
            >下载</el-button
          >
        </div>
      </div>
      <div>
        <p>成果附件:</p>
        <div>
          <el-button
            style="
                  width: 1rem;
                  background: rgb(243, 37, 47);
                  color: #fff;
                  margin-left: 1.15rem;
                "
            @click="dowCg(3)"
            >下载</el-button
          >
        </div>
      </div>
      <div>
        <p>成果进度:</p>
        <div>
          <el-button
            style="width: 1rem; margin-left: 1.15rem"
            type="success"
            @click="getJd(user.ID)"
            >进度</el-button
          >
        </div>
      </div>
    </div>
    <div class="jieguo">
      <i></i>
      <span class="jieguospan">查重结果:</span>
      <span v-if="baogao.wordRepetitionRate" class="repetition"
        >{{ percentage }}相似</span
      >
      <a @click="percentView(2, 0, 4)" style="color: #2d65d2">点击查看</a>
    </div>
    <div class="yijian">
      <div>
        <div></div>
        <span>审核意见：</span>
      </div>
      <div v-if="status != 1 && ideas" class="opinion">{{ ideas }}</div>
      <textarea
        name
        id
        cols="30"
        rows="10"
        v-model="comment"
        v-if="status == 1"
      ></textarea>
    </div>
    <div class="sub" v-if="status == 1">
      <div class="btn" @click="submit(2)">通过</div>
      <div
        class="btn"
        style="margin-left: 0.5rem; background: #d93838"
        @click="submit(3)"
      >
        不通过
      </div>
      <div
        class="btn"
        style="margin-left: 0.5rem; background: #f76423"
        @click="submit(7)"
      >
        暂存
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="reportVisible"
      width="1000px"
      :before-close="handleClose"
    >
      <Preview
        v-if="reportVisible && lookStatus == 1"
        :yulan="yulan"
        :sbbYear="sbbYear"
        :CompanyID="user.CompanyID"
      />
      <FullPreview v-if="reportVisible && lookStatus == 2" :zbg="user.ID" />
    </el-dialog>
    <el-dialog
      title="成果进度"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      center
      top="20vh"
      width="600px"
      style="font-size: 0.2rem"
    >
      <el-steps
        v-if="jindu && jindu.length > 0"
        :active="active"
        direction="vertical"
        align-center
      >
        <el-step :title="item.zt" v-for="(item, i) in jindu" :key="i">
          <template slot="description">
            <div class="content">
              <div>
                <span>{{ item.datetime }}</span>
                <div>{{ item.companyName }}</div>
                <div v-if="item.comment" class="contentMsg">
                  <p style="font-weight: 700; height: 0.3rem">审核意见：</p>
                  <div class="opinion">{{ item.comment }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-step>
        <el-step :title="end.zt" v-if="end.time">
          <template slot="description">
            <span>{{ end.time }}</span>
            <p>{{ end.nextcompanyName }}</p>
          </template>
        </el-step>
      </el-steps>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="percentVisible"
      width="1000px"
      :before-close="handleClose"
    >
      <iframe
        width="1000"
        style="width: 100%"
        height="1000"
        frameborder="0"
        :src="baogaoUrl"
      ></iframe>
    </el-dialog>
  </div>
</template>
<script>
import Preview from "@/views/Declare/Preview";
import FullPreview from "../Declare/FullPreview";
export default {
  data() {
    return {
      title: "",
      reportVisible: false,
      dialogVisible: false,
      percentVisible: false,
      jindu: [],
      useRsubmit: {
        time: "",
        zt: "",
        comment: "",
      },
      end: {
        time: "",
        nextcompanyName: "",
        zt: "",
      },
      lookStatus: "",
    };
  },
  components: {
    Preview,
    FullPreview,
  },
  props: {
    baogao: Object,
    percentage: String,
    user: Object,
    status: String,
    yulan: String,
    sbbYear: String,
    sbb: String,
    zgzbg1: String,
    fj: String,
    baogaoUrl: String,
  },
  methods: {
    view(title, num) {
      this.title = title;
      this.lookStatus = num;
      this.reportVisible = true;
    },
    dowCg(i) {
      if (i == 1) {
        window.location.href = this.sbb;
      } else if (i == 2) {
        window.location.href = this.zgzbg1;
      } else {
        if (this.fj) {
          window.location.href = this.fj;
        } else {
          this.$message({
            message: "暂无附件信息",
            type: "warning",
          });
        }
      }
    },
    getJd(id) {
      let that = this;
      for (let key in that.end) {
        that.end[key] = "";
      }
      this.$axios
        .post(
          "flow/flowtimeline",
          this.$qs.stringify({
            ReportID: id,
            token: sessionStorage.getItem("token"),
          })
        )
        .then((res) => {
          that.jindu = [];
          if (res.data.code == 10000) {
            that.jindu = res.data.data;
            if (this.jindu.length > 0) {
              this.dialogVisible = true;
              that.useRsubmit.time = this.jindu[0].datetime;
              that.useRsubmit.zt = "已提交";
              that.jindu.forEach(function(val, index) {
                // if(val.operation==)
                switch (val.operation) {
                  case "1":
                    val.zt = "待审核";
                    break;
                  case "2":
                    val.zt = "审核通过";
                    break;
                  case "3":
                    val.zt = "审核未通过";
                    break;
                  case "4":
                    val.zt = "待评分";
                    break;
                }
                that.jindu[0].companyName = "";
                that.jindu[0].zt = "已提交";
                if (
                  val.companyName == val.nextcompanyName &&
                  val.operation == 1
                ) {
                  val.zt = "提交成果";
                  val.companyName = "";
                }
                if (
                  index == that.jindu.length - 1 &&
                  val.sysmsg == "审核通过！" &&
                  val.operator != 1
                ) {
                  that.end.time = that.jindu[index].datetime;
                  that.end.zt = "待审核";
                  that.end.nextcompanyName = val.nextcompanyName;
                }
                if (
                  index == that.jindu.length - 1 &&
                  val.sysmsg == "审核通过！" &&
                  val.operator == 1
                ) {
                  that.end.time = that.jindu[index].datetime;
                  that.end.zt = "待评分";
                  that.end.nextcompanyName = val.nextcompanyName;
                }
                if (index == that.jindu.length - 1 && val.companyName == "") {
                  that.end.time = that.jindu[index].datetime;
                  that.end.zt = "待审核";
                  that.end.nextcompanyName = val.nextcompanyName;
                }
                if (
                  index == that.jindu.length - 1 &&
                  val.operation == 3 &&
                  val.companyID != val.nextcompanyID
                ) {
                  that.end.time = that.jindu[index].datetime;
                  that.end.zt = "待审核";
                  that.end.nextcompanyName = val.nextcompanyName;
                }
                if (
                  index == that.jindu.length - 1 &&
                  val.sysmsg === null &&
                  val.operation != 1
                ) {
                  // that.end.time = that.jindu[index].datetime;
                  // that.end.zt = "待评分";
                  // that.end.nextcompanyName ="";
                  for (let key in that.end) {
                    that.end[key] = "";
                  }
                }

                if (
                  val.sysmsg == "审核通过！" &&
                  val.companyName == "中国煤炭工业协会"
                ) {
                  that.jindu = that.jindu.slice(0, index + 1);
                }
                if (that.jindu.length == 0) {
                  that.active = 1;
                } else {
                  that.active = that.jindu.length;
                }
              });
            } else {
              this.$message({
                type: "warning",
                message: "暂无进度信息",
              });
            }
          } else if (res.data.code == 10002) {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    percentView() {
      this.percentVisible = true;
    },
    submit(e, arr) {
      var that = this;
      var fpstatus = this.user["ID"];
      this.$confirm("确认操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$axios
            .post(
              "report/updatestatus?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify({
                ID: arr || fpstatus,
                Status: e,
                comment: this.comment,
              })
            )
            .then((res) => {
              if (res.data.code == 10000) {
                that.comment == "";
                that.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$emit("close", 1);
              } else {
                that.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.info {
  padding: 0.3rem;
  border: 1px #d0d0d0 solid;
  margin-bottom: 0.3rem;

  > div {
    height: 0.7rem;
    display: flex;

    p {
      width: 2rem;
    }
  }

  .span1 {
    margin-left: 0.4rem;
  }

  .span2 {
    margin-left: 0.7rem;
  }

  .span3 {
    margin-left: 0.85rem;
  }

  span {
    display: inline-block;
    color: white;
    width: 1rem;
    text-align: center;
    line-height: 0.5rem;
    height: 0.5rem;
    cursor: pointer;
    background: #2d65d2;
    border-radius: 0.1rem;
  }

  // > div:nth-of-type(5) {
  //   display: flex;
  //   span {
  //     display: inline-block;
  //     width: 2.2rem;
  //   }
  //   div {
  //     margin: 0;
  //     margin-top: 0.1rem;
  //   }
  // }
  > div {
    // margin:0.5rem 0 ;
    // > div {
    //   margin-left: 0.9rem;
    //   line-height: 0.26rem;
    // }
    > span {
      // float: left;
      line-height: 0.5rem;
    }

    .upload {
      cursor: pointer;
      width: 10rem;
      padding-left: 0.5rem;
      background: url(../../assets/back/18.png) left center no-repeat;
    }
  }
}
.jieguo {
  font-size: 0.18rem;
  font-weight: bold;
  margin: 0.5rem 0;
  display: flex;
  align-items: center;

  .repetition {
    width: 1.1rem;
    height: 0.4rem;
    background: #ff0000;
    border-radius: 0.05rem;
    color: #fff;
    text-align: center;
    line-height: 0.4rem;
  }

  .jieguospan {
    color: #1c1c1c;
    margin-left: 0.05rem;
  }

  // line-height: 100%;
  // height: .4rem;
  i {
    display: inline-block;
    width: 0.35rem;
    height: 0.35rem;
    background-image: url("../../assets/back/serach.png");
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: 100% 100%;
    margin-right: 0.05rem;
  }

  span {
    color: #d93838;
    margin-right: 0.2rem;
  }

  a {
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
  }
}
.yijian {
  div:first-of-type {
    display: flex;
    height: 0.35rem;
    align-items: center;

    > div {
      height: 0.05rem;
      width: 0.05rem;
      border-radius: 50%;
      background: #2d65d2;
      margin-right: 0.2rem;
    }
  }

  textarea {
    position: relative;
    top: -0.35rem;
    left: 1.1rem;
    width: 80%;
  }

  .opinion {
    // width: 60%;
    border: 1px solid #ccc;
    padding: 0.1rem;
    margin: 0.15rem 0;
  }
}
.sub {
  width: 100%;
  display: flex;
  justify-content: center;

  div {
    border-radius: 0.1rem;
  }
}
.btn {
  width: 3rem;
  cursor: pointer;
  height: 0.58rem;
  line-height: 0.58rem;
  font-size: 0.17rem;
  text-align: center;
  background: #2d65d2;
  color: #fff;
}
</style>
